// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a6c6e4dc","738":"eb376c1b"}[chunkId] + ".chunk.js";
};